import { splitEntity } from "shelving";
import { type CreatorEntity, type PrivacyTypes, getFollowingAllowedPrivacyTypes, getMemberAllowedPrivacyTypes } from "shared/schema";
import { useFollowedData, useMemberData } from "./data.js";

/** Which rewards/challenges am I authorised to see for a creator entity. */
export function useCreatorAllowedPrivacy(creator: CreatorEntity): PrivacyTypes {
	const [type, id] = splitEntity(creator);
	if (type === "profile") return useProfileAllowedPrivacyTypes(id); // eslint-disable-line react-hooks/rules-of-hooks
	if (type === "group") return useGroupAllowedPrivacyTypes(id); // eslint-disable-line react-hooks/rules-of-hooks
	return ["public"];
}

/** Which rewards/challenges am I authorised to see for a group. */
export function useGroupAllowedPrivacyTypes(gid: string): PrivacyTypes {
	return getMemberAllowedPrivacyTypes(useMemberData(gid));
}

/** Which posts/rewards/challenges am I authorised to see for a profile. */
export function useProfileAllowedPrivacyTypes(uid: string): PrivacyTypes {
	return getFollowingAllowedPrivacyTypes(useFollowedData(uid));
}
